module.exports = __webpack_public_path__ + "static/media/point-20.4af2cfd7.png";